<template>
<div class="popup" v-cloak v-if="removeShow">
    <div class="content" id="delete">
        <div class="title">
            <span>{{$t('language.common.delete')}}</span>
            <div class="icon white-close dialog-close" @click="removeShow=false"></div>
        </div>
        <div class="remove-content">
            {{$t('language.popup.addCloudPopup.removeContent')}}
        </div>
        <div class="delete-footer">
            <button style="float:right;" @click="removeDrive()">{{$t('language.common.delete')}}</button>
        </div>
    </div>
</div>
</template>

<script>
import commonstate from '@/js/constant.js';
import addCloudUtils from '@/js/workspace/add_cloud_utils.js';
import commonUtils from "@/js/workspace/common_util.js";
export default {
    props:['cloudId'],
    data: function () {
        return {
            removeShow: false,
        }
    },
    methods: {
        //删除一个云盘
        removeDrive() {
            let that=this;
            let user = commonUtils.getUser();
            let isDeleted = false; // 标志变量，初始值为false
            let deleteData=new addCloudUtils.deleteDrive(user.id,this.cloudId);
            this.Utils.doDrivesRequest("delete", deleteData).then(res => {
                if(res.status==200 && !isDeleted){
                    let deleteSuccess = this.$parent.deleCloudSuccess(); // 调用上一个删除成功方法并接收返回值
                    if (deleteSuccess) {
                        
                        that.removeShow = false;
                        that.$forceUpdate();
                    }
                }else{
                     this.$toast({
                            text: this.$t('language.exception.'+ res.reason),
                            type: 'fail',
                            idValue: "delete"
                        });
                }
            });
        }
    }
}
</script>

<style>
#delete {
    width: 500px;
    /*no*/
    height: 180px;
    /*no*/
}

.remove-content {
    width: 100%;
    /*no*/
    height: 90px;
    /*no*/
    font-size: 14px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    box-sizing: border-box;
    padding: 20px 20px 0 20px;
    /*no*/
    line-height: 30px;/*no*/

}

.delete-footer {
    width: 100%;
    height: 48px;
    /*no*/
    box-sizing: border-box;
    padding: 0 20px 0 20px;
    /*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/popup/add_cloud_popups/remove_popup.vue